import { registerComponent } from "helpers";
import { WYATTElement } from "wyatt";

registerComponent(
  "searchspring-recommendations",
  class SearchspringRecommendations extends WYATTElement {
    constructor() {
      super();

      this.fetchRecommendations();
    }

    get params() {
      const params = new URLSearchParams({
        ...WYATT.searchspring.tracking,
        limits: this.config.limits,
        tags: this.config.tags,
      });

      if (this.config.product && this.config.tags.includes("cross-sell")) {
        params.set("products", this.config.product);
      }

      return params;
    }

    async fetchRecommendations() {
      const requestUrl = [
        "https://",
        `${WYATT.config.searchspring.siteIds.products}.`,
        `${WYATT.config.searchspring.endpoints.personalizedRecommendations}?`,
        this.params.toString(),
      ].join("");

      const response = await fetch(
        requestUrl,
        WYATT.config.searchspring.options.get,
      );

      const data = await response.json();

      this.render(data);
    }

    render(data) {
      const { results } = data[0];

      results.forEach(this.addProduct.bind(this));
    }

    addProduct(result) {
      const { handle } = result.attributes;
      const classList = this.config.productSummaryClassList || "";

      const productSummaryHTML = `
        <product-summary 
          data-handle="${handle}"
          data-class-list="${classList}"
        ></product-summary>
      `;

      this.innerHTML += productSummaryHTML;
    }
  },
);
